<template>
  <AuthLayout>
    <div>
      <h1 class="text-2xl font-bold text-gray-900">Welcome back</h1>
      <p class="text-sm text-gray-400 mt-1">Sign in to your account</p>
    </div>

    <!-- Error -->
    <div v-if="error" class="mt-5 flex items-start gap-2 p-3 rounded-lg bg-red-50 border border-red-100">
      <svg class="w-4 h-4 text-red-500 mt-0.5 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
      <span class="text-sm text-red-600">{{ error }}</span>
    </div>

    <form @submit.prevent="handleLogin" class="mt-8">
      <div class="space-y-5">
        <div>
          <label class="block text-sm font-medium text-gray-600 mb-1.5">Email</label>
          <input v-model="email" type="email" required autocomplete="email" placeholder="you@company.com" />
        </div>
        <div>
          <div class="flex items-center justify-between mb-1.5">
            <label class="text-sm font-medium text-gray-600">Password</label>
            <router-link to="/forgot-password" class="text-xs text-[var(--color-primary)] hover:underline">Forgot password?</router-link>
          </div>
          <PasswordInput v-model="password" placeholder="Enter your password" :required="true" />
        </div>
      </div>

      <button
        type="submit"
        :disabled="loading"
        class="mt-6 w-full h-11 rounded-lg bg-[var(--color-primary)] hover:bg-[var(--color-primary-hover)] text-white text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {{ loading ? 'Signing in...' : 'Sign in' }}
      </button>
    </form>
  </AuthLayout>
</template>

<script>
import AuthLayout from './AuthLayout.vue'
import PasswordInput from '../../components/PasswordInput.vue'

export default {
  name: 'SignIn',
  components: { AuthLayout, PasswordInput },

  data() {
    return { email: '', password: '', loading: false, error: null }
  },

  methods: {
    async handleLogin() {
      this.loading = true
      this.error = null
      try {
        await this.$store.dispatch('auth/login', { email: this.email, password: this.password })
        this.$router.push('/dashboard')
      } catch (err) {
        this.error = err?.message || 'Invalid credentials. Please try again.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
